// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"dd69ca56c8243738e0cc","966":"25973f3ed2b17396c464"}[chunkId] + ".js";
};